module.exports = __webpack_public_path__ + "img/172.quality_of_the_food.53a19852.svg";